/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
class EmailInputService {
    constructor() {
        this.width = '100%';
        this.placeholder = '';

        // 选择模式
        this.selectMode = 'single';

        // 初始需要展示在input内部的email
        this.initSelectedEmail = '';

        // 选中的email
        this.selectedEmail = '';

        // input error状态
        this.isEmailError = false;

        // error msg
        this.errorMsg = '';

        // nodata label
        this.nodataLabel = '';

        // 是否input无内容时显示下拉框
        this.isAlwaysShowOnFocus = false;

        // 清空选中的email
        this.clearEmail = false;

        // 使用租户模式，只允许选择下拉里的用户，禁止掉输入回车/失焦功能
        this.companyMode = false;
    }

    getEmailList(/* keyword */) {
    }

    getDefaultList() {
    }

    setSelectedEmail(email) {
        this.selectedEmail = email;
    }

    setEmailErrorStatus(status) {
        this.isEmailError = status;
    }

    onEmailError() {
    }

    onEmailErrorHandler() {
        this.setEmailErrorStatus(true);
        this.onEmailError();
    }

    clearSelectedEmail() {
        this.clearEmail = true;
    }

    clearEmailSuccess() {
        this.clearEmail = false;
    }
}

export default EmailInputService;
